import { GetterTree } from "vuex";
import { StudyMode } from "../interfaces";
import { ClassTeachingState } from "./state";
import { OneToOneDto } from "@/services";
import { defineVuexName, MODULES } from "@/store/utils";

const getters: GetterTree<ClassTeachingState, any> = {
  //getSessionId
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_SESSION_ID)](state: ClassTeachingState): string {
    return state.sessionId;
  },
  //isIndependentMode
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_INDEPENDENT_MODE)](state: ClassTeachingState): boolean {
    return state.mode === StudyMode.Independent;
  },
  //getIndependentModeCurrentUnit
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_INDEPENDENT_MODE_CURRENT_UNIT)](state: ClassTeachingState): number | null {
    return state.independentModeCurrentUnit;
  },
  //getIndependentModeCurrentLesson
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_INDEPENDENT_MODE_CURRENT_LESSON)](state: ClassTeachingState): number | null {
    return state.independentModeCurrentLesson;
  },
  //getOneToOneWithHelperIgnoreTeacherVoice
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_ONE_TO_ONE_WITH_HELP_IGNORE_TEACHER_VOICE)](state: ClassTeachingState): boolean {
    return state.oneToOneWithHelperIgnoreTeacherVoice;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_INITIAL_ONE_TO_ONE_DATA)](state: ClassTeachingState): null | OneToOneDto {
    return state.initialOneToOneData;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_INITIAL_CLASS_DATA_SNAPSHOT_EXPOSURE_ID)](state: ClassTeachingState): string | undefined {
    return state.initialClassDataSnapshot.exposureId;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_SOCKET_ATTEMPTED_RECONNECTING)](state: ClassTeachingState): boolean {
    return state.isSocketAttemptedReconnecting;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_INIT_CLASS_FAILED)](state: ClassTeachingState): boolean {
    return state.isInitClassFailed;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_INDEPENDENT_MODE_ENABLED)](state: ClassTeachingState): boolean {
    return state.mode === StudyMode.Independent;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_MUTE_TEACHER_AUDIO_WHEN_ONE_TO_ONE_WITH_HELPER)](state: ClassTeachingState): boolean {
    return state.oneToOneWithHelperIgnoreTeacherVoice;
  },
  [defineVuexName(MODULES.CLASS_TEACHING.GETTERS.GET_IS_RESTORING_SESSION_STATE)](state: ClassTeachingState): boolean {
    return state.isRestoringSessionState;
  },
};

export default getters;
